// Microsoft Entra ID (Azure AD) Configuration
// In development mode (when client ID is not set), authentication is bypassed

import { AZURE_CLIENT_ID, AZURE_API_SCOPE } from './runtimeConfig'

export const msalConfig = {
  auth: {
    clientId: AZURE_CLIENT_ID,
    // Multi-tenant: 'organizations' allows any Azure AD work/school account
    authority: 'https://login.microsoftonline.com/organizations',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // localStorage persists across tabs - when plugin opens a new tab the user stays logged in
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
}

// Scopes for API access
export const loginRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
    AZURE_API_SCOPE,
  ].filter(Boolean),
}

// Scopes for getting access token for your API
export const apiTokenRequest = {
  scopes: [
    AZURE_API_SCOPE,
  ].filter(Boolean),
}

// Check if Microsoft Entra ID is properly configured
export const isMsalConfigured = () => {
  const clientId = AZURE_CLIENT_ID
  return clientId && 
         clientId !== '' && 
         clientId !== 'your-client-id'
}
